import SimulationPageHeader from './SimulationPageHeader'
export default SimulationPageHeader
